module.exports = __webpack_public_path__ + "1_0_59/img/Big Ben.47abfce8.jpg";